// legacy-admin/src/api/admin-domains.js
// 风格沿用 plans.js：httpClient 内 baseURL 已含 /api，本文件路径只写 /admin/...
// 注意：内部 httpClient.get(url, params) 第二参直接就是 params 对象（内部会包到 axios 的 {params} 里），
// 所以这里直接传扁平对象，不要再 {params: ...} 包一层。
import client from './internal/httpClient';

const BASE = '/admin/domains';

export const listDomains   = (params)               => client.get(`${BASE}/list`, params);
export const scanDomains   = ()                     => client.post(`${BASE}/scan`);
export const importDomains = (domains)              => client.post(`${BASE}/import`, { domains });
export const checkDomain   = (id, types = ['all'])  => client.post(`${BASE}/check`, { id, types });
export const fetchChecks   = (id, type = '', limit = 50) => client.get(`${BASE}/checks`, { id, type, limit });
export const updateDomain  = (payload)              => client.post(`${BASE}/update`, payload);
export const deleteDomain  = (id, hard = false)     => client.post(`${BASE}/delete`, { id, hard });
export const setupDomain    = (domain, owner_user_id = null) => client.post(`${BASE}/setup`, { domain, owner_user_id });
export const checkDomainDns = (id) => client.post(`${BASE}/check_dns`, { id });

// 批量新增池子域名:每个域名走完整 cloak 开通(CF zone+A+SSL+建站+目录+证书),约 5~6 秒/个,
// 故用长超时(request 可传 timeout)。单批建议 ≤10 个,前端分批循环调用。
export const batchPoolDomains = (domains) =>
  client.request({ url: `${BASE}/batch-pool`, method: 'post', data: { domains }, timeout: 290000 });

// 刷新 Cloudflare 边缘缓存（purge everything）。单个传 id，批量传 ids 数组。
export const purgeCache = (idOrIds) =>
  client.post(`${BASE}/purge_cache`, Array.isArray(idOrIds) ? { ids: idOrIds } : { id: idOrIds });

// 回填 cf_zone_id。传 id 只回填单个；不传则扫描所有为空的。
export const backfillZone = (id) =>
  client.post(`${BASE}/backfill_zone`, id ? { id } : {});
